/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTELEPHONECONTACTTYPE = {
    Home: 'H',
    Work: 'W',
    Mobile: 'M'
} as const;
export type IAPTELEPHONECONTACTTYPE = typeof IAPTELEPHONECONTACTTYPE[keyof typeof IAPTELEPHONECONTACTTYPE];


export function IAPTELEPHONECONTACTTYPEFromJSON(json: any): IAPTELEPHONECONTACTTYPE {
    return IAPTELEPHONECONTACTTYPEFromJSONTyped(json, false);
}

export function IAPTELEPHONECONTACTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTELEPHONECONTACTTYPE {
    return json as IAPTELEPHONECONTACTTYPE;
}

export function IAPTELEPHONECONTACTTYPEToJSON(value?: IAPTELEPHONECONTACTTYPE | null): any {
    return value as any;
}

